module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.user.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.displayName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header",
    staticStyle: {
      "height": "auto",
      "min-height": "85px",
      "padding-bottom": "15px"
    }
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.user.displayName))]), _vm._v(" "), _vm._l((_vm.user.roles), function(role) {
    return _c('small', {
      key: role
    }, [_vm._v(_vm._s(role))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/logout"
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat btn-block"
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Logout")])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45f39132"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/UserMenu.vue
// module id = 339
// module chunks = 1